<template>
    <div class="ActivationManagementList">
        <HeaderPage></HeaderPage>
        <el-card v-loading="loadingPage">
            <el-row class="borderbody">
                <div class="grid-content">
                    <h1>
                        <b>Ativação por período de credenciamento</b>
                    </h1>
                </div>
                <div class="grid-content">
                    <FilterBox v-on:filterExport="exportDados" v-on:filterList="getActivationData" v-on:filterStatus="filterActivationData" :countStatus="countStatus" :total="0"/>
                </div>
                <div class="grid-content">
                    <el-row class="LinhaTable">
                        <el-col :span="22">
                            <TableSimple :list-data="activationList" >
                                <el-table-column prop="status" label="Ativação" width="120">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.status == 'active'" class="ativo"><b>Ativado</b></span>
                                        <span v-else class="inativo"><b>Não Ativado</b></span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="created_at" label="Data de Cadastro" width="140">
                                    <template slot-scope="scope">
                                        {{moment(scope.row.created_at).format('DD/MM/YY HH:mm')}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="marketplace_name" label="Marketplace" width="180">
                                    <template slot-scope="scope">
                                        <p style="word-break: break-word;">{{ scope.row.marketplace_name }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="document" label="Documento EC" >
                                    <template slot-scope="scope">
                                        {{ (scope.row.business_cnpj) ? scope.row.business_cnpj : scope.row.cpf }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name_store" label="Estabelecimento Comercial" width="180">
                                    <template slot-scope="scope">
                                        <p style="word-break: break-word;">{{ scope.row.name_store }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="phone" label="Telefone" />
                                <el-table-column prop="email" label="E-mail" />
                            </TableSimple>
                        </el-col>
                    </el-row>
                </div>

            </el-row>
        </el-card>
    </div>
</template>

<script>
    import HeaderPage from "@/app/components/HeaderPage";
    import TableSimple from "@/app/components/Table/TableSimple";
    import FilterBox from "@/app/domains/Report/components/ActivationManagement/_filterBox";
    import {getActivationList, getActivationReport} from "@/app/domains/Report/services";
    import {makeErrorFilds} from "@/app/plugins/utils";
  
    export default {
        name: "ActivationManagementList",
        components: {
            FilterBox,
            HeaderPage,
            TableSimple,
        },
        data () {
            return {
                loadingPage: false,
                ActivationData: {},
                activationList: {},
                countStatus: {
                    "active": 0,
                    "inactive": 0,
                },
                filtros: '',
                filtros_status: [],
            }
        },
        methods: {
            init () {
                this.getActivationData('')
            },
            filterActivationData(ruleForm) {
                this.loadingPage = true;
                this.countStatus = {
                    "active": 0,
                    "inactive": 0,
                };
                try {
                    this.filtros_status = ruleForm;
                    this.activationList.data = this.activationData.data.filter(this.filterPersonByStatus)
                } catch (e) {
                    console.log(e);
                }
                this.loadingPage = false;
            },
            filterPersonByStatus(person) {
                this.countStatus[person.status]++;
                if (Array.isArray(this.filtros_status.status) && this.filtros_status.status.length >= 1) {
                    if (this.filtros_status.status.includes(person.status)){
                        return true;
                    }
                } else {
                    return true;
                }
            },
            async getActivationData (query) {
                this.loadingPage = true
                this.filtros = query;
                this.error = {}
                try {
                    let response = await getActivationList(query)
                    this.activationData = response.data;
                    this.activationList = Object.assign({}, this.activationData);
                    this.filterActivationData(this.filtros_status);
                } catch (e) {
                    this.error = makeErrorFilds(e)
                    this.$message({
                    showClose: true,
                    message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
                    type: 'error'
                    })
                } finally {
                    this.loadingPage = false
                }
            },
            async exportDados (query) {
                this.loadingPage = true
                this.error = {}
                try {
                    let response = await getActivationReport(query)
                    if (response.data != undefined && response.data != null) {
                        window.open(response.data, "_blank");
                    } else {
                    this.$message({
                        showClose: true,
                        message: "Não foi encontrado Estabelecimento Comercial",
                        type: "error",
                    });
                    }
                } catch (e) {
                    this.error = makeErrorFilds(e)
                    this.$message({
                    showClose: true,
                    message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
                    type: 'error'
                    })
                } finally {
                    this.loadingPage = false
                }
            }
        },
        mounted() {
            this.init()
        }
    }
</script>  
<style scoped>
    .word-breaker {
        word-break: break-word
    }
    .el-card.processando.is-always-shadow .el-card__body {
        padding: 10px !important;
    }
    .ActivationManagementList .el-card .borderbody {
        border: solid 1px #001730;
        border-radius: 3px;
        padding:10px;
    }
    .LinhaSetas,
    .LinhaTable {
        justify-content: center;
        display: flex;
    }
    .el-card, .el-tabs  {
        max-width: none !important;
    }
    .ativo{
        color: #000000;
    }
    .inativo{
        color: #B00020;
    }
</style>